// filter the object, removing keys with a value of undefined
// only one level
//
const filterUndefined = object => Object.keys(object).reduce((obj, key) => {
	if (object[key] !== undefined) {
		// eslint-disable-next-line no-param-reassign
		obj[key] = object[key]
	}
	return obj
}, {})

export default filterUndefined



// WEBPACK FOOTER //
// ./src/utilities/Data/filterUndefined.js